interface FAQItem {
    question: string;
    answer: string;
}

const FAQ: React.FC = (props) => {
    const faqs: FAQItem[] = [
        {
            question: 'How is IELTS Overall Band (Score) calculated?',
            answer: 'The IELTS Overall Band Score is calculated by taking the average of the total scores of the four components (Listening, Reading, Writing, and Speaking). The score is then rounded to the nearest half or whole band.',
        },
        {
            question: 'Why the lowest component score is important?',
            answer: 'Multiple institutions have a separate criteria for the lowest individual component scores when making admission decisions. e.g. Overall Score requirement is 6.5 but no component can be lower than 6.',
        },
        {
            question: 'Is average band score used anywhere?',
            answer: 'Average IELTS score typically is not considered. Only Overall Score and Individual Scores matters.',
        },
    ];

    return (
        <div className="mt-14 w-full text-slate-700 text-xs bg-slate-50 p-5">
            <h2 className="text-lg font-semibold mb-4">Frequently Asked Questions</h2>
            {faqs.map((faq, index) => (
                <div key={index} className="p-4 border rounded mb-4 -ml-4">
                    <h3 className="font-semibold capitalize">{faq.question}</h3>
                    <p>{faq.answer}</p>
                </div>
            ))}
        </div>
    );
};

export default FAQ;
